export { default } from "./generateOulipoEventStreamProps";
